import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export function useAccountMutation({ reload }) {
  return async function runAccountMutation(action, { success, reset, close } = {}) {
    try {
      const result = await action();
      if (success) toast.success(success);
      if (reset) reset(result);
      if (close) close(false);
      if (reload) reload();
      return result;
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
      return null;
    }
  };
}
